export default function Store() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.25 20.25V15.75C15.25 14.6454 14.3546 13.75 13.25 13.75H10.75C9.64543 13.75 8.75 14.6454 8.75 15.75V20.25M7.875 3.75V7.2M7.875 7.2C7.875 8.33909 6.95159 9.27 5.8125 9.27C4.67341 9.27 3.75 8.33909 3.75 7.2M7.875 7.2C7.875 8.33909 8.79841 9.27 9.9375 9.27C11.0766 9.27 12 8.33909 12 7.2M12 3.75V7.2M12 7.2C12 8.33909 12.9234 9.27 14.0625 9.27C15.2016 9.27 16.125 8.33909 16.125 7.2M16.125 3.75V7.2M16.125 7.2C16.125 8.33909 17.0484 9.27 18.1875 9.27C19.3266 9.27 20.25 8.33909 20.25 7.2M3.75 5.75V18.25C3.75 19.3546 4.64543 20.25 5.75 20.25H18.25C19.3546 20.25 20.25 19.3546 20.25 18.25V5.75C20.25 4.64543 19.3546 3.75 18.25 3.75H5.75C4.64543 3.75 3.75 4.64543 3.75 5.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  )
}
